const CHECKOUT_RETURN_STORAGE_KEY = 'skop.subscription.checkout-return.v1'

export type CheckoutReturn = {
  organizationID: string
  sessionID: string
}

export const rememberCheckoutReturn = ({
  organizationID,
  sessionID,
}: CheckoutReturn): void => {
  if (!organizationID || !sessionID) return
  try {
    window.sessionStorage.setItem(
      CHECKOUT_RETURN_STORAGE_KEY,
      JSON.stringify({ organizationID, sessionID }),
    )
  } catch {
    // Checkout can proceed even when browser correlation storage is unavailable.
  }
}

export const readCheckoutReturn = (
  activeOrganizationID?: string | null,
): CheckoutReturn | null => {
  try {
    const raw = window.sessionStorage.getItem(CHECKOUT_RETURN_STORAGE_KEY)
    if (!raw) return null
    const value = JSON.parse(raw) as Partial<CheckoutReturn>
    if (
      typeof value.organizationID !== 'string' ||
      (activeOrganizationID && value.organizationID !== activeOrganizationID) ||
      typeof value.sessionID !== 'string' ||
      value.sessionID.length === 0
    ) {
      return null
    }
    return {
      organizationID: value.organizationID,
      sessionID: value.sessionID,
    }
  } catch {
    return null
  }
}

export const forgetCheckoutReturn = (): void => {
  try {
    window.sessionStorage.removeItem(CHECKOUT_RETURN_STORAGE_KEY)
  } catch {
    // Nothing else is required after a confirmed return.
  }
}
